import { render, staticRenderFns } from "./TheWizard.vue?vue&type=template&id=00f485b0&scoped=true&"
import script from "./TheWizard.vue?vue&type=script&lang=js&"
export * from "./TheWizard.vue?vue&type=script&lang=js&"
import style0 from "./TheWizard.vue?vue&type=style&index=0&id=00f485b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f485b0",
  null
  
)

export default component.exports